<template>
  <b-container class="container-md" fluid>
    <b-row align-h="end">
      <b-col class="my-1" lg="6">
        <b-form-group class="mb-0" label-align-sm="right" label-cols-sm="3" label-for="filter-input" label-size="sm">
          <b-input-group size="sm">
            <b-form-input id="filter-input" v-model="filter" placeholder="Cerca" type="search" />

            <b-input-group-append>
              <b-button :disabled="!filter" class="btn-warning" @click="filter = ''">
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-table ref="filesTable" :bordered="bordered" :borderless="borderless" :current-page="currentPage" :dark="dark"
      :fields="fields" :filter="filter" :filter-included-fields="filterOn" :fixed="fixed" :foot-clone="footClone"
      :head-variant="headVariant" :hover="hover" :items="files" :no-border-collapse="noCollapse" :outlined="outlined"
      :per-page="perPage" :small="small" :striped="striped" :table-variant="tableVariant" @filtered="onFiltered"
      @row-clicked="toggleSelected" @row-contextmenu="contextMenu" @row-dblclicked="openFolder">
      <template #cell(label_render)="data">
        {{ data.item.label }} {{ (data.item.is_folder ? '' : ' - v.' + data.item.latest_version_name) }}
      </template>
      <template v-slot:cell(selected)="data">
        <b-form-group>
          <BFormCheckbox v-if="$can('update', 'object')" :checked="data.item.selected" type="checkbox"
            @change="toggleSelected(data.item)" />
        </b-form-group>
      </template>
      <template #cell(icon)="data">
        <font-awesome-icon :icon="iconize(data.item)" size="xl" />
      </template>
      <template #cell(expiration_date)="data">
        <ExpirationBadge v-if="data.item.is_folder && hasValidExpiration(data.item)"
          :expiration-date="data.item.expiration_date" />
        <span v-else class="text-muted">&mdash;</span>
      </template>
      <!--      <template #cell(version[0].downloaded_by_username)="data">-->
      <!--      </template>-->

      <template #cell(actions)="data">
        <div @click.stop>
          <FileContextMenu :ref="`${data.item.id}-menu`" :file="data.item" :selected-files="selectedFiles"
            @loading="loading" />
        </div>
      </template>
    </b-table>
    <b-row>
      <b-col class="my-1" md="6" sm="5">
        <b-form-group class="mb-0" label="Per pagina" label-align-sm="right" label-cols-lg="3" label-cols-md="4"
          label-cols-sm="6" label-for="per-page-select" label-size="sm">
          <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions" size="sm" />
        </b-form-group>
      </b-col>

      <b-col class="my-1" md="6" sm="7">
        <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows" align="fill" class="my-0"
          size="sm" />
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import useMyStore from '@/services/useMyStore'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import FileContextMenu from '@/layouts/components/FileContextMenu.vue'
import ExpirationBadge from '@/layouts/components/ExpirationBadge.vue'
import * as expirationHelpers from '@/helpers/expiration-helpers'
import {
  BButton,
  BCol,
  BContainer,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BInputGroup,
  BInputGroupAppend,
  BPagination,
  BRow,
  BTable,
  BFormCheckbox,
} from 'bootstrap-vue'

export default {
  name: 'FilesTable',
  components: {
    FileContextMenu,
    ExpirationBadge,
    BTable,
    BContainer,
    BRow,
    BCol,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BFormSelect,
    BPagination,
    FontAwesomeIcon,
    BFormCheckbox,
  },
  props: {
    files: {
      type: Array,
      required: true,
    },
    selectedFiles: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      items: this.files,
      fields: [
        {
          key: 'selected',
          label: '',
          sortable: false,
          thClass: 'text-center',
        },
        {
          key: 'icon',
          label: '',
          sortable: false,
        },
        {
          key: 'label_render',
          label: 'Name',
          sortable: true,
        },
        {
          key: 'created_at',
          label: 'Data Creazione',
          sortable: true,
        },
        {
          key: 'updated_at',
          label: 'Data Modifica',
          sortable: true,
        },
        {
          key: 'expiration_date',
          label: 'Scadenza',
          sortable: false,
        },
        {
          key: 'version[0].downloaded_by_username',
          label: 'Ultimo Download',
        },
        {
          key: 'version[0].created_by_username',
          label: 'Creato da',
        },
        {
          key: 'actions',
          label: 'Azioni',
          sortable: false,
          thStyle: {
            width: '1%',
          },
        },
      ],
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark',
      ],
      striped: false,
      bordered: false,
      borderless: false,
      outlined: false,
      small: false,
      hover: true,
      dark: false,
      fixed: false,
      footClone: false,
      headVariant: null,
      tableVariant: '',
      noCollapse: false,
      filter: null,
      filterOn: ['label'],
      perPage: 20,
      pageOptions: [2, 5, 10, 20, 50, 100],
      currentPage: 1,
    }
  },
  setup() {
    const { currentFolder } = useMyStore()

    return {
      currentFolder,
    }
  },
  computed: {
    totalRows() {
      return this.files.length
    },
  },
  methods: {
    hasValidExpiration(item) {
      return expirationHelpers.normalizeDate(item.expiration_date) !== null
    },
    iconize(data) {
      if (data.is_folder) {
        return 'folder'
      }
      let icon = 'file'
      switch (data.file_types) {
        case 'pdf':
          icon = 'file-pdf'
          break
        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'git':
          icon = 'image'
          break
        case 'txt':
          icon = 'file-lines'
          break
        case 'doc':
        case 'docx':
          icon = 'file-word'
          break
        case 'xls':
        case 'xlsx':
          icon = 'file-excel'
          break
        case 'csv':
          icon = 'file-csv'
          break
        case 'flv':
        case 'webm':
        case 'mkv':
        case 'avi':
        case 'wmv':
        case 'mp4':
          icon = 'file-video'
          break
        case 'aac':
        case 'mp3':
        case '3gp':
        case 'aa':
        case 'm4a':
        case 'wma':
        case 'ogg':
          icon = 'file-audio'
          break
        case 'xml':
          icon = 'file-code'
          break
        case 'zip':
          icon = 'file-zipper'
          break
        default:
          icon = 'file'
          break
      }
      return icon
    },
    contextMenu(item, index, event) {
      // mi passa item (file), index e event
      event.preventDefault()
      const menu = this.$refs[`${item.id}-menu`]
      menu.open(item)
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    openFolder(item) {
      if (item.is_folder === 1) {
        this.$emit('open-folder', item)
      }
    },
    toggleSelected(item) {
      const file = this.files.find(x => x.id === item.id)
      this.$emit('select', file)
    },
    loading(show) {
      this.$emit('loading', show)
    },
  },
}
</script>

<style scoped>
td {
  padding: 0 !important;
}
</style>
